module.exports = __webpack_public_path__ + "static/media/html.cedf99cf.svg";